export default __webpack_public_path__ + "static/media/button_point-on.8db22191.svg";